import { KpiCard } from "../../../lib/funnel/charts";
import { fmtN, fmtPct } from "../../../lib/funnel/helpers";
import { OVERALL_DEFINITION } from "../definitions";
import type { Entity } from "../helpers";

export function KpiTiles({
  entity,
  current,
  previous,
  seatPct,
  windowLabel,
}: {
  entity: Entity;
  current: number;
  previous: number;
  seatPct: number | null;
  windowLabel: string;
}) {
  const hasPrior = previous > 0;
  const delta = current - previous;
  const deltaPct = hasPrior ? (delta / previous) * 100 : 0;
  const tone = delta >= 0 ? "success" : "danger";
  const noun = entity === "user" ? "users" : "companies";
  return (
    <div className="kpi-grid">
      <KpiCard
        label={`Active ${noun} (${windowLabel})`}
        value={fmtN(current)}
        sub={`Distinct active ${noun}`}
        tone="primary"
        info={OVERALL_DEFINITION}
      />
      <KpiCard
        label="MoM change"
        value={hasPrior ? `${deltaPct >= 0 ? "+" : ""}${deltaPct.toFixed(1)}%` : "—"}
        sub={hasPrior ? `${delta >= 0 ? "+" : ""}${fmtN(delta)} vs 4 weeks prior` : "no comparison week"}
        tone={tone}
        info={`Percent change vs the same week 4 weeks earlier. Positive means more ${noun} were active.`}
      />
      {entity === "company" && seatPct != null && (
        <KpiCard
          label="% of seats active"
          value={fmtPct(seatPct, 100)}
          sub="Avg across active companies"
          tone="muted"
          info="For each company that had at least one active user this period, divide active_users by marloo_active_user_count, then average across those companies."
        />
      )}
    </div>
  );
}
